<template>
  <div class="main">
    <div class="dingdan">
      <content-wamp>
        <order-schedule slot="content"></order-schedule>
      </content-wamp>
    </div>
    <div class="other_gxu">
      <div class="one">
        <content-wamp>
          <img slot="top" src="~@/assets/image/标题2.png" alt="" />
          <yield slot="content"></yield>
        </content-wamp>
        <content-wamp>
          <img slot="top" src="~@/assets/image/标题4.png" alt="" />
          <area-warning slot="content"></area-warning>
        </content-wamp>
      </div>
      <div class="two">
        <content-wamp class="one_item">
          <img slot="top" src="~@/assets/image/标题3.png" alt="" />
          <process slot="content"></process>
        </content-wamp>
        <content-wamp class="two_item">
          <img slot="top" src="~@/assets/image/标题5.png" alt="" />
          <inventory slot="content"></inventory>
        </content-wamp>
      </div>
    </div>
  </div>
</template>

<script>
import ContentWamp from "@/common/ContentWamp";
import OrderSchedule from "@/components/order/OrderSchedule";
import Yield from "@/components/yield/Yield";
import AreaWarning from "@/components/areWarning/AreaWarning";
import Process from '@/components/process/Process';
import Inventory from '@/components/inventory/Inventory'
export default {
  name: "MainCenter",
  components: {
    ContentWamp,
    OrderSchedule,
    Yield,
    AreaWarning,
    Process,
    Inventory
  },
};
</script>

<style lang="less">
.main {
  width: 95%;
  height: 97%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 0;
    top: -5rem;
    background: url("../assets/image/背景1.png") no-repeat;
    background-size: 100% 100%;
  }
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    z-index: 0;
    background: url("../assets/image/背景2.png") no-repeat;
    background-size: 100% 100%;
  }
  .title {
    width: 100%;
    font-size: 1.25rem;
    text-align: center;
    color: rgb(210, 255, 255);
  }
  .dingdan {
    width: 100%;
    height: 40%;
  }
  .other_gxu {
    width: 100%;
    height: 55%;
    box-sizing: content-box;
    position: relative;
    z-index: 100;
    display: flex;
    padding-bottom: 6.25rem;
    justify-content: space-around;
    div {
      display: flex;
      // justify-content: space-around;
      flex-direction: column;
    }
    .one {
      width: 30%;
      display: flex;
      flex-direction: column;
      &>div{
        height: 45%;
      }
    }
    .two {
      width: 70%;
      height: 100%;
      &>div:nth-child(1){
        height: 35%;
      }
      &>div:nth-child(2){
        height: 40%;
      }
      .one_item {
        flex: 2;
      }
      .two_item {
        flex: 3;
      }
    }
  }
}
</style>